export const INTERESTS_ATTRIBUTE_OPTION_ID = "$interests";
